import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import "./BranchCreationModal.scss";
import getStyles from "./getStyles";
import InputField from "../InputField";
import { FormControl } from "@material-ui/core";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";

const BranchCreationModal = (props: any) => {
  const classes = getStyles();
  const [name, setName] = useState<string>("");
  const [contactName, setContactName] = useState<string>("");
  const [streetAddress, setStreetAddress] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [county, setCounty] = useState<string>("");
  const [postCode, setPostCode] = useState<string>("");
  const [intrafinId, setIntrafinId] = useState<string>("");
  const [deliveryMethod, setDeliveryMethod] = useState<string>("");
  const [sellingDealType, setSellingDealType] = useState<string>("");
  const [buyingDealType, setBuyingDealType] = useState<string>("");
  const [valueDateModifier, setValueDateModifier] = useState<string>("0");
  const [despatchDateModifier, setDespatchDateModifier] = useState<string>("0");
  const [returnValueDateModifier, setReturnValueDateModifier] = useState<
    string
  >("0");
  const [returnDespatchDateModifier, setReturnDespatchDateModifier] = useState<
    string
  >("0");
  const [isDirty, setIsDirty] = useState<boolean>(false);
  const [clickedActionButton, setClickedActionButton] = useState<boolean>(
    false
  );

  useEffect(() => {
    setClickedActionButton(false);

    if (props.value && props.value.id) {
      setName(props.value.name);
      setContactName(props.value.contactName);
      setStreetAddress(props.value.streetAddress);
      setCity(props.value.city);
      setCounty(props.value.county);
      setPostCode(props.value.postCode);
      setIntrafinId(props.value.intrafinId);
      setDeliveryMethod(props.value.deliveryMethod.toString());
      setSellingDealType(props.value.sellingDealType.toString());
      setBuyingDealType(
        props.value.buyingDealType ? props.value.buyingDealType.toString() : "0"
      );
      setValueDateModifier(props.value.valueDateModifier);
      setDespatchDateModifier(props.value.despatchDateModifier);
      setReturnValueDateModifier(props.value.returnValueDateModifier);
      setReturnDespatchDateModifier(props.value.returnDespatchDateModifier);
    } else {
      setName("");
      setContactName("");
      setStreetAddress("");
      setCity("");
      setCounty("");
      setPostCode("");
      setIntrafinId("");
      setDeliveryMethod("0");
      setSellingDealType("0");
      setBuyingDealType("0");
      setValueDateModifier("0");
      setDespatchDateModifier("0");
      setReturnValueDateModifier("0");
      setReturnDespatchDateModifier("0");
    }
  }, [props.open]);

  function handleCreate() {
    setClickedActionButton(true);

    if (name === "" || streetAddress === "" || postCode === "") {
      setIsDirty(true);
    } else {
      setIsDirty(false);
      props.onCreate({
        name,
        contactName,
        streetAddress,
        city,
        county,
        postCode,
        intrafinId,
        deliveryMethod,
        sellingDealType,
        buyingDealType,
        valueDateModifier,
        despatchDateModifier,
        returnValueDateModifier,
        returnDespatchDateModifier
      });
    }
  }

  function handleUpdate() {
    setClickedActionButton(true);

    if (name === "" || streetAddress === "" || postCode === "") {
      setIsDirty(true);
    } else {
      setIsDirty(false);
      props.onUpdate({
        name,
        contactName,
        streetAddress,
        city,
        county,
        postCode,
        intrafinId,
        deliveryMethod,
        sellingDealType,
        buyingDealType,
        valueDateModifier,
        despatchDateModifier,
        returnValueDateModifier,
        returnDespatchDateModifier
      });
    }
  }

  function handleClose() {
    props.close();
    setClickedActionButton(false);
  }

  return (
    <Dialog
      className="BranchCreationModal-dialog"
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      maxWidth={"md"}
    >
      <DialogTitle className={classes.titleBar}>
        {props.action === "Add" ? "Create Branch" : "Edit Branch"}
      </DialogTitle>
      <DialogContent>
        <div>
          <div className="BranchDetails--formContainer">
            <InputField
              containerClassName={"BranchDetails-BranchName"}
              inputProps={{ maxLength: 100 }}
              fieldName={"Branch Name"}
              textFieldClassName={"BranchDetails-BranchName-text"}
              type={"text"}
              value={name}
              onChange={(evt: any) => setName(evt.target.value)}
              placeHolder={"Required"}
              errorOutline={isDirty && name === ""}
              errorMessage={isDirty && name === "" ? "Enter a branch name" : ""}
              errorMessageClassName={"BranchDetails-errorMsgText"}
              clickedActionButton={clickedActionButton}
            />
            <InputField
              containerClassName={"BranchDetails-ContactName"}
              inputProps={{ maxLength: 128 }}
              fieldName={"Contact Name"}
              textFieldClassName={"BranchDetails-ContactNameText"}
              type={"text"}
              value={contactName}
              onChange={(evt: any) => setContactName(evt.target.value)}
            />
            <InputField
              containerClassName={"BranchDetails-StreetAddress"}
              inputProps={{ maxLength: 64 }}
              fieldName={"Street Address"}
              textFieldClassName={"BranchDetails-AddressDetailsText"}
              type={"text"}
              value={streetAddress}
              onChange={(evt: any) => setStreetAddress(evt.target.value)}
              placeHolder={"Required"}
              errorOutline={isDirty && streetAddress === ""}
              errorMessage={
                isDirty && streetAddress === "" ? "Enter a street address" : ""
              }
              errorMessageClassName={"BranchDetails-errorMsgText"}
              clickedActionButton={clickedActionButton}
            />
            <InputField
              containerClassName={"BranchDetails-City"}
              inputProps={{ maxLength: 64 }}
              fieldName={"City"}
              textFieldClassName={"BranchDetails-CityText"}
              type={"text"}
              value={city}
              onChange={(evt: any) => setCity(evt.target.value)}
            />
            <InputField
              containerClassName={"BranchDetails-County"}
              inputProps={{ maxLength: 64 }}
              fieldName={"County/State"}
              textFieldClassName={"BranchDetails-CountyStateText"}
              type={"text"}
              value={county}
              onChange={(evt: any) => setCounty(evt.target.value)}
            />
            <InputField
              containerClassName={"BranchDetails-PostCode"}
              inputProps={{ maxLength: 9 }}
              fieldName={"Post Code"}
              textFieldClassName={"BranchDetails-PostCodeText"}
              type={"text"}
              value={postCode}
              onChange={(evt: any) => setPostCode(evt.target.value)}
              placeHolder={"Required"}
              errorOutline={isDirty && postCode === ""}
              errorMessage={
                isDirty && postCode === "" ? "Enter a postcode" : ""
              }
              errorMessageClassName={"BranchDetails-errorMsgText"}
              clickedActionButton={clickedActionButton}
            />
            <InputField
              containerClassName={"BranchDetails-IntrafinId"}
              inputProps={{ maxLength: 11 }}
              fieldName={"Intrafin ID"}
              textFieldClassName={"BranchDetails-IntrafinIdText"}
              type={"text"}
              value={intrafinId}
              onChange={(evt: any) => setIntrafinId(evt.target.value)}
            />
            <div
              className={`InputField--input-container BranchDetails-DeliveryMethod`}
            >
              <div className="InputField--input-label">Delivery Method</div>
              <FormControl component="fieldset">
                <RadioGroup
                  className={classes.radioGroup}
                  aria-label="Delivery Method"
                  name="Delivery Method"
                  value={deliveryMethod}
                  onChange={(evt: any) => setDeliveryMethod(evt.target.value)}
                >
                  <FormControlLabel
                    value="0"
                    control={<Radio className="DeliveryMethod-None" />}
                    label="None"
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio className="DeliveryMethod-RMSVan1" />}
                    label="RMS Van 1"
                  />
                  <FormControlLabel
                    value="2"
                    control={<Radio className="DeliveryMethod-RMSVan2" />}
                    label="RMS Van 2"
                  />
                  <FormControlLabel
                    value="3"
                    control={<Radio className="DeliveryMethod-G4STrunking" />}
                    label="G4S Trunking"
                  />
                  <FormControlLabel
                    value="4"
                    control={
                      <Radio className="DeliveryMethod-RegisteredMail" />
                    }
                    label="Registered Mail"
                  />
                  <FormControlLabel
                    value="5"
                    control={<Radio className="DeliveryMethod-G4SVan" />}
                    label="G4S Van"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div
              className={`InputField--input-container BranchDetails-DealType`}
            >
              <div className="InputField--input-label">Selling Deal Type</div>
              <FormControl component="fieldset">
                <RadioGroup
                  className={classes.radioGroup}
                  aria-label="Selling Deal Type"
                  name="SellingDealType"
                  value={sellingDealType}
                  onChange={(evt: any) => setSellingDealType(evt.target.value)}
                >
                  <FormControlLabel
                    value="0"
                    control={<Radio className="SellingDealType-None" />}
                    label="None"
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio className="SellingDealType-BNDSL" />}
                    label="BNDSL"
                  />
                  <FormControlLabel
                    value="2"
                    control={<Radio className="SellingDealType-DOROP" />}
                    label="DOROP"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div
              className={`InputField--input-container BranchDetails-BuyingDealType`}
            >
              <div className="InputField--input-label">Buying Deal Type</div>
              <FormControl component="fieldset">
                <RadioGroup
                  className={classes.radioGroup}
                  aria-label="Buying Deal Type"
                  name="buyingDealType"
                  value={buyingDealType}
                  onChange={(evt: any) => setBuyingDealType(evt.target.value)}
                >
                  <FormControlLabel
                    value="0"
                    control={<Radio className="BuyingDealType-NotApplicable" />}
                    label="None"
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio className="BuyingDealType-PODOC" />}
                    label="PODOC"
                  />
                  <FormControlLabel
                    value="2"
                    control={<Radio className="BuyingDealType-BNDBY" />}
                    label="BNDBY"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <InputField
              containerClassName={"BranchDetails-ValueDateModifier"}
              fieldName={"Order Value Date Modifier"}
              textFieldClassName={"UserDetails-ValueDateModifierText"}
              type={"number"}
              value={valueDateModifier}
              onChange={(evt: any) => {
                const pv = Math.abs(parseFloat(evt.target.value)).toString();
                if (pv === "NaN") {
                  setValueDateModifier("");
                } else {
                  if (parseFloat(pv) > 10) {
                    setValueDateModifier("10");
                  } else {
                    setValueDateModifier(pv);
                  }
                }
              }}
              inputProps={{ min: 0, max: 10 }}
              errorMessage={
                isDirty && valueDateModifier === ""
                  ? "Enter a value between 0 and 10"
                  : ""
              }
              errorOutline={isDirty && valueDateModifier === ""}
              clickedActionButton={clickedActionButton}
            />
            <InputField
              containerClassName={"BranchDetails-DespatchDateModifier"}
              fieldName={"Order Despatch Date Modifier"}
              textFieldClassName={"UserDetails-DespatchDateModifierText"}
              type={"number"}
              value={despatchDateModifier}
              onChange={(evt: any) => {
                const pv = Math.abs(parseFloat(evt.target.value)).toString();
                if (pv === "NaN") {
                  setDespatchDateModifier("");
                } else {
                  if (parseFloat(pv) > 10) {
                    setDespatchDateModifier("10");
                  } else {
                    setDespatchDateModifier(pv);
                  }
                }
              }}
              inputProps={{ min: 0, max: 10 }}
              errorMessage={
                isDirty && despatchDateModifier === ""
                  ? "Enter a value between 0 and 10"
                  : ""
              }
              errorOutline={isDirty && despatchDateModifier === ""}
              clickedActionButton={clickedActionButton}
            />

            <InputField
              containerClassName={"BranchDetails-ReturnValueDateModifier"}
              fieldName={"Return Value Date Modifier"}
              textFieldClassName={"UserDetails-ReturnValueDateModifierText"}
              type={"number"}
              value={returnValueDateModifier}
              onChange={(evt: any) => {
                const pv = Math.abs(parseFloat(evt.target.value)).toString();
                if (pv === "NaN") {
                  setReturnValueDateModifier("");
                } else {
                  if (parseFloat(pv) > 10) {
                    setReturnValueDateModifier("10");
                  } else {
                    setReturnValueDateModifier(pv);
                  }
                }
              }}
              inputProps={{ min: 0, max: 10 }}
              errorMessage={
                isDirty && returnValueDateModifier === ""
                  ? "Enter a value between 0 and 10"
                  : ""
              }
              errorOutline={isDirty && returnValueDateModifier === ""}
              clickedActionButton={clickedActionButton}
            />
            <InputField
              containerClassName={"BranchDetails-ReturnDespatchDateModifier"}
              fieldName={"Return Despatch Date Modifier"}
              textFieldClassName={"UserDetails-ReturnDespatchDateModifierText"}
              type={"number"}
              value={returnDespatchDateModifier}
              onChange={(evt: any) => {
                const pv = Math.abs(parseFloat(evt.target.value)).toString();
                if (pv === "NaN") {
                  setReturnDespatchDateModifier("");
                } else {
                  if (parseFloat(pv) > 10) {
                    setReturnDespatchDateModifier("10");
                  } else {
                    setReturnDespatchDateModifier(pv);
                  }
                }
              }}
              inputProps={{ min: 0, max: 10 }}
              errorMessage={
                isDirty && returnDespatchDateModifier === ""
                  ? "Enter a value between 0 and 10"
                  : ""
              }
              errorOutline={isDirty && returnDespatchDateModifier === ""}
              clickedActionButton={clickedActionButton}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          className="BranchCreationModal-cancel"
          color="secondary"
          onClick={() => handleClose()}
        >
          Cancel
        </Button>
        {props.action === "Add" ? (
          <Button
            className="BranchCreationModal-create"
            color="primary"
            onClick={() => handleCreate()}
          >
            Create
          </Button>
        ) : (
          <Button
            className="BranchCreationModal-save"
            color="primary"
            onClick={() => handleUpdate()}
          >
            Save
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default BranchCreationModal;
